function Projects() {
    return (
      <div className="pb-20 bg-[#1A191A]">
        <h2>This is our projects screen</h2>
      </div>
    );
  }

  export default Projects;